// Client domains on the site page (issue #83).
export const domainsEn = {
  'domain.title': 'Domains',
  'domain.hint': 'Put the site on the client’s own domains. Each domain moves to our Cloudflare account; the client only changes its nameservers. The primary domain is the site’s address and has the CMS; the others redirect to it.',
  'domain.notConnected': 'Domains are not connected yet: the console has no Cloudflare token or account.',
  'domain.limit': 'Domains: {used} of {limit} ({package} package)',
  'domain.over.title': '{over} over the {package} limit',
  'domain.over.body': 'The site has {connected} connected domains and its package allows {limit}. Nothing is removed automatically: remove an extra domain, or raise the limit under Package.',
  'domain.siteWarning.body': 'Domains: the site has more connected domains than its package allows. See Domains below.',
  'domain.empty': 'No domain yet. The site answers on its digimasi.com address.',
  'domain.add': 'Add domain',
  'domain.add.cancel': 'Cancel',
  'domain.add.notInPackage': 'The {package} package does not include an own domain. Change the package, or give this site a domain limit under Package.',
  'domain.add.atLimit': 'The {package} package allows {limit} and the site has {used}. Remove a domain, or raise the limit under Package.',
  'domain.primary': 'Primary',
  'domain.redirects': 'Redirects to {domain}',
  'domain.details.show': 'Show DNS records',
  'domain.details.hide': 'Hide DNS records',
  'domain.makePrimary': 'Make primary',
  'domain.makingPrimary': 'Switching…',
  'domain.makePrimary.title': 'Make {domain} the primary domain?',
  'domain.makePrimary.body':
    'The website moves to {web} and the CMS to {cms}. {old} and the other domains then redirect to it, and {oldCms} stops opening the CMS. Records that will be replaced: {records}.',
  'domain.madePrimary': 'Primary domain changed. Rebuild the website once under Website builds.',
  'domain.form.domain': 'Client’s domain',
  'domain.form.domainHint': 'The main domain, such as example.co.id (no www, no subdomain).',
  'domain.form.admin': 'CMS subdomain',
  'domain.form.adminHint': 'The CMS will be at {host}.',
  'domain.form.submit': 'Add domain',
  'domain.form.submitting': 'Adding…',
  'domain.added': 'Domain added. Send the nameservers to the client.',
  'domain.status.pending_ns': 'Waiting for nameservers',
  'domain.status.active': 'Active',
  'domain.status.attached': 'Connected',
  'domain.status.error': 'Error',
  'domain.lastChecked': 'Last checked {when}',
  'domain.check': 'Check now',
  'domain.checking': 'Checking…',
  'domain.checked': 'Status checked',
  'domain.ns.title': 'Nameservers to send the client',
  'domain.ns.explain':
    'Ask the client to log in where they bought the domain (their registrar) and replace the current nameservers with these two. Nothing else changes for them. The switch usually takes a few hours, sometimes up to a day. Their email keeps working as long as the records below are complete.',
  'domain.ns.copy': 'Copy',
  'domain.ns.copyBoth': 'Copy both',
  'domain.ns.copied': 'Copied',
  'domain.hosts.title': 'Addresses',
  'domain.hosts.web': 'Website',
  'domain.hosts.cms': 'CMS',
  'domain.records.title': 'DNS records',
  'domain.records.hint': 'What Cloudflare imported from the client’s current DNS. Check the email records against their current settings before they switch.',
  'domain.records.empty': 'No records imported.',
  'domain.records.noMx': 'No MX record. If the client uses email on this domain, add their MX records before they switch.',
  'domain.records.error': 'The records could not be read: {error}',
  'domain.records.col.type': 'Type',
  'domain.records.col.name': 'Name',
  'domain.records.col.content': 'Content',
  'domain.records.col.email': 'Email',
  'domain.records.email.mx': 'Mail server',
  'domain.records.email.spf': 'SPF',
  'domain.records.email.dkim': 'DKIM',
  'domain.records.email.dmarc': 'DMARC',
  'domain.records.email.autodiscover': 'Mail setup',
  'domain.records.replaced': 'Replaced on connect',
  'domain.record.add': 'Add a record',
  'domain.record.type': 'Type',
  'domain.record.name': 'Name',
  'domain.record.nameHint': '@ for the domain itself, or a name such as mail',
  'domain.record.content': 'Content',
  'domain.record.priority': 'Priority',
  'domain.record.submit': 'Add record',
  'domain.record.added': 'Record added',
  'domain.connect': 'Connect site',
  'domain.connecting': 'Connecting…',
  'domain.connect.hint': 'The zone is active. Connecting points these addresses at the site and tells the site its new address.',
  'domain.connect.hintExtra': 'The zone is active. Connecting points {hosts} at the site; they redirect to {primary}.',
  'domain.connect.title': 'Connect {name} to {domain}?',
  'domain.connect.body': 'Addresses: {hosts}. Records that will be replaced: {records}.',
  'domain.connect.none': 'none',
  'domain.connected': 'Site connected to its domain',
  'domain.rebuildNote':
    'The public website must be rebuilt once with its new address ({url}): press Rebuild now under Website builds.',
  'domain.remove': 'Remove domain',
  'domain.remove.title': 'Remove {domain}?',
  'domain.remove.body': 'Its Cloudflare zone is deleted too. The client’s nameservers must not point to us.',
  'domain.remove.bodyConnected': 'Its addresses stop pointing to the site and no longer redirect. Its Cloudflare zone stays, because the client’s nameservers and email records still use it.',
  'domain.removed': 'Domain removed',
  'apiError.cfNotConnected': 'Domains are not connected yet: the console has no Cloudflare token or account',
  'apiError.cfZoneElsewhere': 'This domain is already on another Cloudflare account. Whoever controls that account must remove it there before we can add it.',
  'apiError.cfTokenRefused': 'Cloudflare refused the console’s token: check its permissions (see the README)',
  'apiError.cfNotRegistered': 'Cloudflare says this is not a registered domain',
  'apiError.cfUnreachable': 'Cloudflare could not be reached',
  'apiError.domainInvalid': 'Enter a domain such as example.com',
  'apiError.domainSubdomain': 'Enter the main domain (such as example.com), not a subdomain',
  'apiError.domainPlatform': 'Addresses under digimasi.com are ours: enter the client’s own domain',
  'apiError.domainTaken': 'This domain is already used by a site',
  'apiError.notInPackage': 'This site’s package does not include an own domain',
  'apiError.atLimit': 'This site already has as many domains as its package allows',
  'apiError.connectOverLimit': 'This site already has as many connected domains as its package allows',
  'apiError.noDomain': 'This site has no such domain',
  'apiError.domainNotActive': 'The domain is not active yet: the client has not switched the nameservers',
  'apiError.domainAttached': 'The domain is already connected to the site',
  'apiError.recordsChanged': 'The DNS records changed since you looked. Check them again before connecting.',
  'apiError.primaryCannotRemove': 'The primary domain cannot be removed. Make another connected domain primary first.',
  'apiError.primaryNotConnected': 'Only a connected domain can be the primary one',
  'apiError.alreadyPrimary': 'This domain is already the primary one',
  'apiError.zoneKept': 'A connected domain keeps its zone: the client’s nameservers still point to it',
  'apiError.recordOutside': 'The name must be inside the client’s domain',
  'apiError.zoneLost': 'The zone was moved away or deleted in Cloudflare: the client’s nameservers no longer point to us',
  'domain.mail': 'Mail domain',
  'domain.mail.hint': 'The site’s Inbox takes mail for this domain. It stays put when the primary changes.',
  'domain.mail.none': 'No mail domain yet: the Inbox only takes mail for the site’s digimasi.com address.',
  'domain.mail.make': 'Make mail domain',
  'domain.mail.title': 'Move the mail domain to {domain}',
  'domain.mail.titleSet': 'Make {domain} the mail domain',
  'domain.mail.loading': 'Reading the mailbox…',
  'domain.mail.from': 'The Inbox takes mail for {to} from now on, and refuses mail for {from}.',
  'domain.mail.fromNone': 'The Inbox takes mail for {to} from now on. Nothing is deleted: the site has no mail domain yet.',
  'domain.mail.affected': 'These addresses on {from} are deleted, with all their mail. The people given them lose access:',
  'domain.mail.col.address': 'Address',
  'domain.mail.col.people': 'People',
  'domain.mail.col.messages': 'Messages',
  'domain.mail.noAddresses': 'No listed addresses on {from}.',
  'domain.mail.other': 'Other mail to {from} (catch-all): {n} messages, also deleted.',
  'domain.mail.request': 'Carries out the client’s request of {date}: “{note}”',
  'domain.mail.ack': 'I understand: the addresses and mail above are deleted, and this cannot be undone.',
  'domain.mail.confirm': 'Move the mail domain',
  'domain.mail.moving': 'Moving…',
  'domain.mail.cancel': 'Cancel',
  'domain.mail.moved': 'Mail domain moved to {to}: {addresses} addresses and {messages} messages deleted.',
  'apiError.mailCannotRemove': 'The mail domain cannot be removed. Move the mail domain to another connected domain first.',
  'apiError.mailNotConnected': 'Only a connected domain can be the mail domain',
  'apiError.alreadyMail': 'This domain is already the mail domain',
  'req.title': 'Client requests',
  'req.hint': 'What the client asked for from its CMS: help connecting a domain, or a change of the mail domain.',
  'req.pageTitle': 'Requests',
  'req.pageHint': 'Every site’s requests from its CMS. Close each as done or rejected; the client sees your note.',
  'req.empty': 'No requests.',
  'req.filter.open': 'Open',
  'req.filter.all': 'All',
  'req.kind.domain_help': 'Help connecting a domain',
  'req.kind.mail_domain_change': 'Mail-domain change',
  'req.status.open': 'Open',
  'req.status.done': 'Done',
  'req.status.rejected': 'Rejected',
  'req.from': 'From {who} · {date}',
  'req.domain': 'Domain: {domain}',
  'req.noNote': 'No note.',
  'req.answer': 'Our answer: {note}',
  'req.resolvedBy': 'Closed by {who} · {date}',
  'req.staffNote': 'Note for the client (optional)',
  'req.done': 'Mark done',
  'req.reject': 'Reject',
  'req.closed': 'Request closed',
  'req.mailHint': 'Carry it out under Domains: Make mail domain on the domain the client wants.',
  'req.openSite': 'Open site',
  'shell.nav.requests': 'Requests',
} as const

export const domainsId: Record<keyof typeof domainsEn, string> = {
  'domain.title': 'Domain',
  'domain.hint': 'Pasang situs di domain milik klien. Tiap domain dipindahkan ke akun Cloudflare kita; klien hanya mengganti nameserver-nya. Domain utama jadi alamat situs dan tempat CMS; domain lain dialihkan ke sana.',
  'domain.notConnected': 'Domain belum terhubung: console belum memiliki token atau akun Cloudflare.',
  'domain.limit': 'Domain: {used} dari {limit} (paket {package})',
  'domain.over.title': 'Lebih {over} dari batas paket {package}',
  'domain.over.body': 'Situs ini punya {connected} domain terhubung, sedangkan paketnya membolehkan {limit}. Tidak ada yang dihapus otomatis: hapus domain tambahan, atau naikkan batasnya di Paket.',
  'domain.siteWarning.body': 'Domain: situs ini punya lebih banyak domain terhubung daripada yang dibolehkan paketnya. Lihat Domain di bawah.',
  'domain.empty': 'Belum ada domain. Situs masih memakai alamat digimasi.com-nya.',
  'domain.add': 'Tambah domain',
  'domain.add.cancel': 'Batal',
  'domain.add.notInPackage': 'Paket {package} tidak termasuk domain sendiri. Ganti paketnya, atau beri situs ini batas domain di Paket.',
  'domain.add.atLimit': 'Paket {package} membolehkan {limit} dan situs ini sudah punya {used}. Hapus satu domain, atau naikkan batasnya di Paket.',
  'domain.primary': 'Utama',
  'domain.redirects': 'Dialihkan ke {domain}',
  'domain.details.show': 'Lihat record DNS',
  'domain.details.hide': 'Sembunyikan record DNS',
  'domain.makePrimary': 'Jadikan utama',
  'domain.makingPrimary': 'Mengganti…',
  'domain.makePrimary.title': 'Jadikan {domain} domain utama?',
  'domain.makePrimary.body':
    'Website pindah ke {web} dan CMS ke {cms}. {old} dan domain lain lalu dialihkan ke sana, dan {oldCms} tidak lagi membuka CMS. Record yang akan diganti: {records}.',
  'domain.madePrimary': 'Domain utama diganti. Build ulang website sekali di Build situs web.',
  'domain.form.domain': 'Domain klien',
  'domain.form.domainHint': 'Domain utama, misalnya example.co.id (tanpa www, tanpa subdomain).',
  'domain.form.admin': 'Subdomain CMS',
  'domain.form.adminHint': 'CMS akan berada di {host}.',
  'domain.form.submit': 'Tambah domain',
  'domain.form.submitting': 'Menambahkan…',
  'domain.added': 'Domain ditambahkan. Kirim nameserver ke klien.',
  'domain.status.pending_ns': 'Menunggu nameserver',
  'domain.status.active': 'Aktif',
  'domain.status.attached': 'Terhubung',
  'domain.status.error': 'Galat',
  'domain.lastChecked': 'Terakhir diperiksa {when}',
  'domain.check': 'Periksa sekarang',
  'domain.checking': 'Memeriksa…',
  'domain.checked': 'Status diperiksa',
  'domain.ns.title': 'Nameserver untuk dikirim ke klien',
  'domain.ns.explain':
    'Minta klien masuk ke tempat mereka membeli domain (registrar) dan mengganti nameserver yang ada dengan dua nameserver ini. Selain itu tidak ada yang berubah bagi mereka. Peralihan biasanya memakan beberapa jam, kadang hingga sehari. Email mereka tetap berjalan selama record di bawah lengkap.',
  'domain.ns.copy': 'Salin',
  'domain.ns.copyBoth': 'Salin keduanya',
  'domain.ns.copied': 'Disalin',
  'domain.hosts.title': 'Alamat',
  'domain.hosts.web': 'Website',
  'domain.hosts.cms': 'CMS',
  'domain.records.title': 'Record DNS',
  'domain.records.hint': 'Yang diimpor Cloudflare dari DNS klien saat ini. Cocokkan record email dengan pengaturan mereka sekarang sebelum mereka beralih.',
  'domain.records.empty': 'Tidak ada record yang diimpor.',
  'domain.records.noMx': 'Tidak ada record MX. Jika klien memakai email di domain ini, tambahkan record MX mereka sebelum beralih.',
  'domain.records.error': 'Record tidak dapat dibaca: {error}',
  'domain.records.col.type': 'Tipe',
  'domain.records.col.name': 'Nama',
  'domain.records.col.content': 'Isi',
  'domain.records.col.email': 'Email',
  'domain.records.email.mx': 'Server email',
  'domain.records.email.spf': 'SPF',
  'domain.records.email.dkim': 'DKIM',
  'domain.records.email.dmarc': 'DMARC',
  'domain.records.email.autodiscover': 'Pengaturan email',
  'domain.records.replaced': 'Diganti saat dihubungkan',
  'domain.record.add': 'Tambah record',
  'domain.record.type': 'Tipe',
  'domain.record.name': 'Nama',
  'domain.record.nameHint': '@ untuk domain itu sendiri, atau nama seperti mail',
  'domain.record.content': 'Isi',
  'domain.record.priority': 'Prioritas',
  'domain.record.submit': 'Tambah record',
  'domain.record.added': 'Record ditambahkan',
  'domain.connect': 'Hubungkan situs',
  'domain.connecting': 'Menghubungkan…',
  'domain.connect.hint': 'Zona sudah aktif. Menghubungkan mengarahkan alamat-alamat ini ke situs dan memberi tahu situs alamat barunya.',
  'domain.connect.hintExtra': 'Zona sudah aktif. Menghubungkan mengarahkan {hosts} ke situs; alamat itu dialihkan ke {primary}.',
  'domain.connect.title': 'Hubungkan {name} ke {domain}?',
  'domain.connect.body': 'Alamat: {hosts}. Record yang akan diganti: {records}.',
  'domain.connect.none': 'tidak ada',
  'domain.connected': 'Situs terhubung ke domainnya',
  'domain.rebuildNote':
    'Website publik harus dibangun ulang sekali dengan alamat barunya ({url}): tekan Build ulang sekarang di Build situs web.',
  'domain.remove': 'Hapus domain',
  'domain.remove.title': 'Hapus {domain}?',
  'domain.remove.body': 'Zona Cloudflare-nya juga dihapus. Nameserver klien tidak boleh mengarah ke kita.',
  'domain.remove.bodyConnected': 'Alamatnya tidak lagi mengarah ke situs dan tidak dialihkan lagi. Zona Cloudflare-nya tetap ada, karena nameserver dan record email klien masih memakainya.',
  'domain.removed': 'Domain dihapus',
  'apiError.cfNotConnected': 'Domain belum terhubung: console belum memiliki token atau akun Cloudflare',
  'apiError.cfZoneElsewhere': 'Domain ini sudah ada di akun Cloudflare lain. Pemilik akun itu harus menghapusnya di sana sebelum kita dapat menambahkannya.',
  'apiError.cfTokenRefused': 'Cloudflare menolak token console: periksa izinnya (lihat README)',
  'apiError.cfNotRegistered': 'Menurut Cloudflare ini bukan domain yang terdaftar',
  'apiError.cfUnreachable': 'Cloudflare tidak dapat dijangkau',
  'apiError.domainInvalid': 'Masukkan domain seperti example.com',
  'apiError.domainSubdomain': 'Masukkan domain utama (misalnya example.com), bukan subdomain',
  'apiError.domainPlatform': 'Alamat di bawah digimasi.com milik kita: masukkan domain milik klien',
  'apiError.domainTaken': 'Domain ini sudah dipakai oleh sebuah situs',
  'apiError.notInPackage': 'Paket situs ini tidak termasuk domain sendiri',
  'apiError.atLimit': 'Situs ini sudah punya domain sebanyak yang dibolehkan paketnya',
  'apiError.connectOverLimit': 'Situs ini sudah punya domain terhubung sebanyak yang dibolehkan paketnya',
  'apiError.noDomain': 'Situs ini tidak punya domain tersebut',
  'apiError.domainNotActive': 'Domain belum aktif: klien belum mengganti nameserver',
  'apiError.domainAttached': 'Domain sudah terhubung ke situs',
  'apiError.recordsChanged': 'Record DNS berubah sejak Anda melihatnya. Periksa lagi sebelum menghubungkan.',
  'apiError.primaryCannotRemove': 'Domain utama tidak bisa dihapus. Jadikan domain terhubung lain sebagai utama dulu.',
  'apiError.primaryNotConnected': 'Hanya domain yang sudah terhubung yang bisa jadi domain utama',
  'apiError.alreadyPrimary': 'Domain ini sudah jadi domain utama',
  'apiError.zoneKept': 'Domain yang terhubung tetap menyimpan zonanya: nameserver klien masih mengarah ke sana',
  'apiError.recordOutside': 'Nama harus berada di dalam domain klien',
  'apiError.zoneLost': 'Zona dipindahkan atau dihapus di Cloudflare: nameserver klien tidak lagi mengarah ke kita',
  'domain.mail': 'Domain email',
  'domain.mail.hint': 'Inbox situs menerima email untuk domain ini. Tetap di sini walau domain utama berganti.',
  'domain.mail.none': 'Belum ada domain email: Inbox hanya menerima email untuk alamat digimasi.com situs.',
  'domain.mail.make': 'Jadikan domain email',
  'domain.mail.title': 'Pindahkan domain email ke {domain}',
  'domain.mail.titleSet': 'Jadikan {domain} domain email',
  'domain.mail.loading': 'Membaca Inbox…',
  'domain.mail.from': 'Mulai sekarang Inbox menerima email untuk {to} dan menolak email untuk {from}.',
  'domain.mail.fromNone': 'Mulai sekarang Inbox menerima email untuk {to}. Tidak ada yang dihapus: situs belum punya domain email.',
  'domain.mail.affected': 'Alamat di {from} ini dihapus beserta semua emailnya. Orang yang diberi alamat ini kehilangan aksesnya:',
  'domain.mail.col.address': 'Alamat',
  'domain.mail.col.people': 'Orang',
  'domain.mail.col.messages': 'Email',
  'domain.mail.noAddresses': 'Tidak ada alamat terdaftar di {from}.',
  'domain.mail.other': 'Email lain ke {from} (catch-all): {n} email, ikut dihapus.',
  'domain.mail.request': 'Menjalankan permintaan klien tanggal {date}: “{note}”',
  'domain.mail.ack': 'Saya paham: alamat dan email di atas dihapus, dan ini tidak bisa dibatalkan.',
  'domain.mail.confirm': 'Pindahkan domain email',
  'domain.mail.moving': 'Memindahkan…',
  'domain.mail.cancel': 'Batal',
  'domain.mail.moved': 'Domain email dipindah ke {to}: {addresses} alamat dan {messages} email dihapus.',
  'apiError.mailCannotRemove': 'Domain email tidak bisa dihapus. Pindahkan domain email ke domain terhubung lain dulu.',
  'apiError.mailNotConnected': 'Hanya domain yang sudah terhubung yang bisa jadi domain email',
  'apiError.alreadyMail': 'Domain ini sudah jadi domain email',
  'req.title': 'Permintaan klien',
  'req.hint': 'Yang diminta klien dari CMS-nya: bantuan menghubungkan domain, atau ganti domain email.',
  'req.pageTitle': 'Permintaan',
  'req.pageHint': 'Permintaan dari CMS semua situs. Tutup tiap permintaan sebagai selesai atau ditolak; klien melihat catatan Anda.',
  'req.empty': 'Tidak ada permintaan.',
  'req.filter.open': 'Terbuka',
  'req.filter.all': 'Semua',
  'req.kind.domain_help': 'Bantuan menghubungkan domain',
  'req.kind.mail_domain_change': 'Ganti domain email',
  'req.status.open': 'Terbuka',
  'req.status.done': 'Selesai',
  'req.status.rejected': 'Ditolak',
  'req.from': 'Dari {who} · {date}',
  'req.domain': 'Domain: {domain}',
  'req.noNote': 'Tanpa catatan.',
  'req.answer': 'Jawaban kita: {note}',
  'req.resolvedBy': 'Ditutup oleh {who} · {date}',
  'req.staffNote': 'Catatan untuk klien (opsional)',
  'req.done': 'Tandai selesai',
  'req.reject': 'Tolak',
  'req.closed': 'Permintaan ditutup',
  'req.mailHint': 'Jalankan di Domain: Jadikan domain email pada domain yang diinginkan klien.',
  'req.openSite': 'Buka situs',
  'shell.nav.requests': 'Permintaan',
}

/** The API's fixed English messages about domains (worker/routes/domains.ts, lib/cloudflare.ts, lib/domains.ts, console-schema domain-names). */
export const DOMAIN_SERVER_MESSAGE_KEYS: Record<string, keyof typeof domainsEn> = {
  'Domains are not connected yet: the console has no Cloudflare token or account': 'apiError.cfNotConnected',
  'This domain is already on another Cloudflare account. Whoever controls that account must remove it there before we can add it.': 'apiError.cfZoneElsewhere',
  'Cloudflare refused the console’s token: check that it has the permissions listed in the README': 'apiError.cfTokenRefused',
  'Cloudflare says this is not a registered domain': 'apiError.cfNotRegistered',
  'Cloudflare could not be reached': 'apiError.cfUnreachable',
  'Enter a domain such as example.com': 'apiError.domainInvalid',
  'Enter the main domain (such as example.com), not a subdomain': 'apiError.domainSubdomain',
  'Addresses under digimasi.com are ours: enter the client’s own domain': 'apiError.domainPlatform',
  'This domain is already used by a site': 'apiError.domainTaken',
  'This site’s package does not include an own domain': 'apiError.notInPackage',
  'This site already has as many domains as its package allows': 'apiError.atLimit',
  'This site already has as many connected domains as its package allows': 'apiError.connectOverLimit',
  'This site has no such domain': 'apiError.noDomain',
  'The domain is not active yet: the client has not switched the nameservers': 'apiError.domainNotActive',
  'The domain is already connected to the site': 'apiError.domainAttached',
  'The DNS records changed since you looked. Check them again before connecting.': 'apiError.recordsChanged',
  'The primary domain cannot be removed. Make another connected domain primary first.': 'apiError.primaryCannotRemove',
  'Only a connected domain can be the primary one': 'apiError.primaryNotConnected',
  'This domain is already the primary one': 'apiError.alreadyPrimary',
  'A connected domain keeps its zone: the client’s nameservers still point to it': 'apiError.zoneKept',
  'The name must be inside the client’s domain': 'apiError.recordOutside',
  'The zone was moved away or deleted in Cloudflare: the client’s nameservers no longer point to us': 'apiError.zoneLost',
  'The mail domain cannot be removed. Move the mail domain to another connected domain first.': 'apiError.mailCannotRemove',
  'Only a connected domain can be the mail domain': 'apiError.mailNotConnected',
  'This domain is already the mail domain': 'apiError.alreadyMail',
}
